import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=10c17519&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c17519')) {
      api.createRecord('10c17519', component.options)
    } else {
      api.reload('10c17519', component.options)
    }
    module.hot.accept("./terms.vue?vue&type=template&id=10c17519&", function () {
      api.rerender('10c17519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/terms.vue"
export default component.exports